export default __webpack_public_path__ + "static/media/alliance.5b3aeccb.png";